import SweetAlert from "sweetalert2";
import { LI } from "../../../../../../AbstractElements";
import { Href } from "../../../../../../Constants/Constants";
import { useAppDispatch, useAppSelector } from "../../../../../../ReduxToolkit/Hooks";
import { deletedUser, setTempId } from "../../../../../../ReduxToolkit/Reducers/ContactReducer";
import { EditDeleteLinkProps, UserCallbackUserType, UserProps } from "../../../../../../Types/ContactType";
import { Fragment } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import { setSelectedUser } from "../../../../../../ReduxToolkit/Reducers/ChatSlice";

const EditDeleteLink: React.FC<EditDeleteLinkProps> = ({ selectedUser, userEditCallback }) => {
  const { users } = useAppSelector((state) => state.contact);
  const dispatch = useAppDispatch();
  const editUsers = (usersData: UserCallbackUserType) => {
    if (usersData.id !== undefined) {
      dispatch(setTempId(usersData.id));
      userEditCallback(true, usersData as UserProps);
    }
  };
  const onDeleteUser = (userId: number | undefined) => {
      SweetAlert.fire({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this imaginary file!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ok",
        cancelButtonText: "cancel",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          dispatch(deletedUser(userId));
          const newUsers= users.filter((user) => user.id !== userId)
          if (newUsers.length > 0) {
              dispatch(setSelectedUser(newUsers[0]));
          } else {
              dispatch(setSelectedUser(null));
          }            
          SweetAlert.fire("Deleted!", "Your file has been deleted.", "success");
        } else {
          SweetAlert.fire("Your imaginary file is safe!");
        }
      });
  };
  return (
    <Fragment>
      <LI>
        <Link to={Href} onClick={() => editUsers(selectedUser)}>{"Edit"}</Link>
      </LI>
      <LI>
        <Link to={Href} onClick={() => onDeleteUser(selectedUser.id)}>{"Delete"}</Link>
      </LI>
    </Fragment>
  );
};
export default EditDeleteLink;